module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/32.f070409d.png";